import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import FAQ from "components/FAQ/FAQ";

export interface PageContactProps {
  className?: string;
  asSection?: boolean;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg
        width="70"
        height="71"
        viewBox="0 0 70 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 5.96875C0 3.20733 2.23858 0.96875 5 0.96875H65C67.7614 0.96875 70 3.20733 70 5.96875V65.9688C70 68.7302 67.7614 70.9688 65 70.9688H5C2.23858 70.9688 0 68.7302 0 65.9688V5.96875Z"
          fill="#18CC3D"
        />
        <path
          d="M35 20.9688C33.6722 20.9688 32.4417 21.3007 31.3083 21.9646C30.175 22.6285 29.2764 23.5271 28.6125 24.6604C27.9486 25.7937 27.6167 27.0243 27.6167 28.3521C27.6167 29.7965 28.4958 31.8465 30.2542 34.5021C31.3875 36.1826 32.7347 37.9604 34.2958 39.8354C34.4931 40.0715 34.7278 40.1896 35 40.1896C35.2722 40.1896 35.5069 40.0715 35.7042 39.8354C37.2653 37.9604 38.6125 36.1826 39.7458 34.5021C41.5042 31.8465 42.3833 29.7965 42.3833 28.3521C42.3833 27.0243 42.0514 25.7937 41.3875 24.6604C40.7236 23.5271 39.825 22.6285 38.6917 21.9646C37.5583 21.3007 36.3278 20.9688 35 20.9688ZM35 30.8146C34.3361 30.8146 33.7597 30.5701 33.2708 30.0813C32.7819 29.5924 32.5375 29.016 32.5375 28.3521C32.5375 27.6882 32.7819 27.1118 33.2708 26.6229C33.7597 26.134 34.3361 25.8896 35 25.8896C35.6639 25.8896 36.2403 26.134 36.7292 26.6229C37.2181 27.1118 37.4625 27.6882 37.4625 28.3521C37.4625 29.016 37.2181 29.5924 36.7292 30.0813C36.2403 30.5701 35.6639 30.8146 35 30.8146ZM26.2708 30.8146L19.2958 33.6271C18.9458 33.7826 18.6625 34.016 18.4458 34.3271C18.2319 34.641 18.125 34.9924 18.125 35.3812V50.0312C18.125 50.3451 18.2611 50.5993 18.5333 50.7938C18.8083 50.9882 19.1014 51.0271 19.4125 50.9104L27.5 47.2188V33.5646C26.9528 32.5896 26.5431 31.6729 26.2708 30.8146ZM35 42.0646C34.1417 42.0646 33.4194 41.7312 32.8333 41.0646C31.5444 39.5035 30.3917 38.0007 29.375 36.5562V47.2188L40.625 50.9688V36.5562C39.6083 38.0007 38.4556 39.5035 37.1667 41.0646C36.5806 41.7312 35.8583 42.0646 35 42.0646ZM50.5875 30.4021L42.5 34.0938V50.9688L50.7042 47.6896C51.0542 47.5312 51.3375 47.2965 51.5542 46.9854C51.7681 46.6715 51.875 46.3201 51.875 45.9312V31.2812C51.875 30.9701 51.7389 30.716 51.4667 30.5188C51.1917 30.3243 50.8986 30.2854 50.5875 30.4021Z"
          fill="white"
        />
      </svg>
    ),
    title: "Office Location",
    detail: globalJson.address,
  },
  {
    id: 2,
    icon: (
      <svg
        width="70"
        height="71"
        viewBox="0 0 70 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 5.5625C0 2.80108 2.23858 0.5625 5 0.5625H65C67.7614 0.5625 70 2.80108 70 5.5625V65.5625C70 68.3239 67.7614 70.5625 65 70.5625H5C2.23858 70.5625 0 68.3239 0 65.5625V5.5625Z"
          fill="#18CC3D"
        />
        <path
          d="M48.8876 22.0292L42.7918 20.6209C42.4806 20.5431 42.1681 20.582 41.8543 20.7375C41.5431 20.8931 41.3293 21.1084 41.2126 21.3834L38.4001 27.9459C38.2806 28.257 38.2612 28.5597 38.3418 28.8542C38.4195 29.1459 38.5751 29.3903 38.8084 29.5875L42.3251 32.5167C41.2695 34.7806 39.8529 36.8111 38.0751 38.6084C36.2973 40.4056 34.257 41.832 31.9543 42.8875L29.0834 39.3709C28.8862 39.0986 28.632 38.9334 28.3209 38.875C28.007 38.8139 27.714 38.8431 27.4418 38.9625L20.8793 41.775C20.5654 41.8917 20.3306 42.1056 20.1751 42.4167C20.0195 42.7306 19.9806 43.0431 20.0584 43.3542L21.4668 49.45C21.5056 49.8 21.6612 50.0736 21.9334 50.2709C22.2084 50.4653 22.5015 50.5625 22.8126 50.5625C27.7348 50.5625 32.3056 49.332 36.5251 46.8709C40.6251 44.4486 43.8862 41.1875 46.3084 37.0875C48.7695 32.8681 50.0001 28.2972 50.0001 23.375C50.0001 23.0639 49.9029 22.7709 49.7084 22.4959C49.5112 22.2236 49.2376 22.0681 48.8876 22.0292Z"
          fill="white"
        />
      </svg>
    ),
    title: "Phone",
    detail: globalJson.phone,
  },
  {
    id: 3,
    icon: (
      <svg
        width="70"
        height="71"
        viewBox="0 0 70 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 5.15625C0 2.39483 2.23858 0.15625 5 0.15625H65C67.7614 0.15625 70 2.39483 70 5.15625V65.1562C70 67.9177 67.7614 70.1562 65 70.1562H5C2.23858 70.1562 0 67.9177 0 65.1562V5.15625Z"
          fill="#18CC3D"
        />
        <path
          d="M50 31.9354V47.3438C50 48.1243 49.7264 48.7882 49.1792 49.3354C48.6319 49.8826 47.9681 50.1562 47.1875 50.1562H22.8125C22.0319 50.1562 21.3681 49.8826 20.8208 49.3354C20.2736 48.7882 20 48.1243 20 47.3438V31.9354C20 30.9965 20.3514 30.2535 21.0542 29.7063C22.6569 28.4563 25.8792 26.0743 30.7208 22.5604L31.25 22.1479C32.0306 21.5229 32.6556 21.0938 33.125 20.8604C33.8667 20.391 34.4917 20.1562 35 20.1562C35.5083 20.1562 36.1333 20.391 36.875 20.8604C37.3444 21.0938 37.9694 21.5229 38.75 22.1479L39.2792 22.5604C44.1208 26.0743 47.3431 28.4563 48.9458 29.7063C49.6486 30.2535 50 30.9965 50 31.9354ZM46.6583 36.6229L46.1333 35.8021C46.0556 35.7243 45.9583 35.666 45.8417 35.6271C45.7222 35.5854 45.6042 35.6049 45.4875 35.6854L38.75 40.6646C37.9694 41.2896 37.3444 41.7188 36.875 41.9521C36.1333 42.4215 35.5083 42.6562 35 42.6562C34.4917 42.6562 33.8667 42.4215 33.125 41.9521C32.6556 41.7188 32.0306 41.2896 31.25 40.6646L24.5125 35.6854C24.3958 35.6049 24.2778 35.5854 24.1583 35.6271C24.0417 35.666 23.9444 35.7243 23.8667 35.8021L23.3417 36.6229C23.2611 36.7007 23.2306 36.8076 23.25 36.9438C23.2722 37.0799 23.3222 37.1868 23.4 37.2646L30.1958 42.1896C31.0931 42.8924 31.8347 43.3993 32.4208 43.7104C33.3597 44.2576 34.2194 44.5312 35 44.5312C35.7806 44.5312 36.6403 44.2576 37.5792 43.7104C38.1653 43.3993 38.9069 42.8924 39.8042 42.1896L46.6 37.2646C46.6806 37.1868 46.7306 37.0799 46.75 36.9438C46.7694 36.8076 46.7389 36.7007 46.6583 36.6229Z"
          fill="white"
        />
      </svg>
    ),
    title: "Email",
    detail: globalJson.email,
  },
];

const PageContact: FC<PageContactProps> = ({
  className = "",
  asSection = false,
}) => {
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const payload = {
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(payload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      {!asSection && (
        <Helmet>
          <title>Contact</title>
        </Helmet>
      )}
      <div className="container ">
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-24  rounded-lg py-16 px-12">
          <div>
            <div className="py-4"></div>
            <form className="grid grid-cols-1 gap-6" onSubmit={sendEmail}>
              <h2 className="text-5xl font-semibold">
                You can connect with us when need help!
              </h2>
              <label className="block">
                <Input
                  placeholder="Name"
                  type="text"
                  className="mt-1"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Input
                  type="email"
                  placeholder="Email"
                  className="mt-1"
                  value={getEmail}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Textarea
                  className="mt-1"
                  placeholder="Message"
                  rows={6}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </label>
              <div>
                <ButtonPrimary type="submit" className="min-w-[200px]">
                  {loading ? (
                    <div className="flex justify-center items-center col-span-full">
                      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </ButtonPrimary>
              </div>
            </form>
          </div>
          <div className=" text-white p-6 rounded-lg ">
            {/* Contact Items */}
            <div className="space-y-6">
              {/* Phone */}
              <div className="flex flex-col items-start">
                <h3 className="text-lg font-semibold">Have Questions?</h3>
                <div className="flex items-center gap-2 text-[#FDE306]">
                  <svg
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9176 7.9637C12.647 7.9637 13.3465 8.25344 13.8622 8.76916C14.3779 9.28489 14.6676 9.98436 14.6676 10.7137C14.6676 10.9568 14.7642 11.19 14.9361 11.3619C15.108 11.5338 15.3412 11.6304 15.5843 11.6304C15.8274 11.6304 16.0606 11.5338 16.2325 11.3619C16.4044 11.19 16.501 10.9568 16.501 10.7137C16.501 9.49813 16.0181 8.33234 15.1585 7.4728C14.299 6.61326 13.1332 6.13037 11.9176 6.13037C11.6745 6.13037 11.4414 6.22695 11.2695 6.39886C11.0976 6.57077 11.001 6.80392 11.001 7.04704C11.001 7.29015 11.0976 7.52331 11.2695 7.69522C11.4414 7.86713 11.6745 7.9637 11.9176 7.9637Z"
                      fill="#FDE306"
                    />
                    <path
                      d="M11.9176 4.29696C13.6194 4.29696 15.2516 4.973 16.4549 6.17635C17.6583 7.37971 18.3343 9.01182 18.3343 10.7136C18.3343 10.9567 18.4309 11.1899 18.6028 11.3618C18.7747 11.5337 19.0079 11.6303 19.251 11.6303C19.4941 11.6303 19.7273 11.5337 19.8992 11.3618C20.0711 11.1899 20.1676 10.9567 20.1676 10.7136C20.1676 8.52559 19.2984 6.42717 17.7513 4.87999C16.2041 3.33282 14.1057 2.46362 11.9176 2.46362C11.6745 2.46362 11.4414 2.5602 11.2695 2.73211C11.0976 2.90402 11.001 3.13717 11.001 3.38029C11.001 3.6234 11.0976 3.85656 11.2695 4.02847C11.4414 4.20038 11.6745 4.29696 11.9176 4.29696Z"
                      fill="#FDE306"
                    />
                    <path
                      d="M19.9382 15.2145C19.8877 15.0673 19.8007 14.9354 19.6852 14.8312C19.5698 14.7269 19.4297 14.6538 19.2782 14.6186L13.7782 13.3628C13.6289 13.3289 13.4735 13.333 13.3262 13.3746C13.1788 13.4163 13.0443 13.4941 12.9348 13.6011C12.8065 13.7203 12.7973 13.7295 12.2015 14.8661C10.2244 13.9551 8.64023 12.3644 7.73732 10.3836C8.90148 9.79696 8.91065 9.79696 9.02982 9.65946C9.1368 9.54997 9.21466 9.41543 9.25629 9.26812C9.29792 9.12081 9.302 8.96541 9.26815 8.81612L8.01232 3.38029C7.97716 3.22876 7.90402 3.08867 7.79978 2.97321C7.69555 2.85775 7.56364 2.77071 7.41648 2.72029C7.20241 2.64383 6.98135 2.58857 6.75648 2.55529C6.5248 2.50157 6.28837 2.47086 6.05065 2.46362C4.93232 2.46362 3.8598 2.90788 3.06902 3.69866C2.27824 4.48943 1.83398 5.56196 1.83398 6.68029C1.83884 10.4228 3.32768 14.0106 5.97402 16.6569C8.62036 19.3033 12.2082 20.7921 15.9507 20.797C16.5044 20.797 17.0527 20.6879 17.5643 20.476C18.0759 20.2641 18.5407 19.9535 18.9323 19.5619C19.3238 19.1704 19.6344 18.7055 19.8463 18.1939C20.0583 17.6823 20.1673 17.134 20.1673 16.5803C20.1676 16.347 20.1492 16.114 20.1123 15.8836C20.0738 15.6559 20.0155 15.432 19.9382 15.2145Z"
                      fill="#FDE306"
                    />
                  </svg>

                  <span>{globalJson.phone}</span>
                </div>
              </div>
              <hr className="border-gray-600" />

              {/* Email */}
              <div className="flex flex-col items-start">
                <h3 className="text-lg font-semibold">Write Email</h3>
                <div className="flex items-center gap-2 text-[#FDE306]">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <mask
                      id="mask0_1261_2898"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="19"
                    >
                      <rect
                        y="0.630127"
                        width="18"
                        height="18"
                        fill="url(#pattern0_1261_2898)"
                      />
                    </mask>
                    <g mask="url(#mask0_1261_2898)">
                      <rect
                        x="-13.5"
                        y="-9.49487"
                        width="44.7188"
                        height="38.25"
                        fill="#FDE306"
                      />
                    </g>
                    <defs>
                      <pattern
                        id="pattern0_1261_2898"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_1261_2898"
                          transform="scale(0.0078125)"
                        />
                      </pattern>
                      <image
                        id="image0_1261_2898"
                        width="128"
                        height="128"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>

                  <span>{globalJson.email}</span>
                </div>
              </div>
              <hr className="border-gray-600" />

              {/* Address */}
              <div className="flex flex-col items-start">
                <h3 className="text-lg font-semibold">Visit Office</h3>
                <div className="flex items-center gap-2 text-[#FDE306]">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <mask
                      id="mask0_1261_2909"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="21"
                    >
                      <rect
                        y="0.630127"
                        width="20"
                        height="20"
                        fill="url(#pattern0_1261_2909)"
                      />
                    </mask>
                    <g mask="url(#mask0_1261_2909)">
                      <rect
                        x="-2.65625"
                        y="-3.43237"
                        width="26.7188"
                        height="26.5625"
                        fill="#FDE306"
                      />
                    </g>
                    <defs>
                      <pattern
                        id="pattern0_1261_2909"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_1261_2909"
                          transform="scale(0.0078125)"
                        />
                      </pattern>
                      <image
                        id="image0_1261_2909"
                        width="128"
                        height="128"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>

                  <span>{globalJson.address}</span>
                </div>
              </div>
              <hr className="border-gray-600" />
              <div className="flex space-x-3">
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.389648"
                    y="0.870117"
                    width="45"
                    height="45"
                    rx="22.5"
                    fill="#ECF0F4"
                  />
                  <path
                    d="M26.6084 24.3701H24.2646V31.3701H21.1396V24.3701H18.5771V21.4951H21.1396V19.2764C21.1396 16.7764 22.6396 15.3701 24.9209 15.3701C26.0146 15.3701 27.1709 15.5889 27.1709 15.5889V18.0576H25.8896C24.6396 18.0576 24.2646 18.8076 24.2646 19.6201V21.4951H27.0459L26.6084 24.3701Z"
                    fill="#121212"
                  />
                </svg>
                <svg
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.389648"
                    y="0.870117"
                    width="45"
                    height="45"
                    rx="22.5"
                    fill="#ECF0F4"
                  />
                  <path
                    d="M22.8896 19.7764C24.8584 19.7764 26.4834 21.4014 26.4834 23.3701C26.4834 25.3701 24.8584 26.9639 22.8896 26.9639C20.8896 26.9639 19.2959 25.3701 19.2959 23.3701C19.2959 21.4014 20.8896 19.7764 22.8896 19.7764ZM22.8896 25.7139C24.1709 25.7139 25.2021 24.6826 25.2021 23.3701C25.2021 22.0889 24.1709 21.0576 22.8896 21.0576C21.5771 21.0576 20.5459 22.0889 20.5459 23.3701C20.5459 24.6826 21.6084 25.7139 22.8896 25.7139ZM27.4521 19.6514C27.4521 20.1201 27.0771 20.4951 26.6084 20.4951C26.1396 20.4951 25.7646 20.1201 25.7646 19.6514C25.7646 19.1826 26.1396 18.8076 26.6084 18.8076C27.0771 18.8076 27.4521 19.1826 27.4521 19.6514ZM29.8271 20.4951C29.8896 21.6514 29.8896 25.1201 29.8271 26.2764C29.7646 27.4014 29.5146 28.3701 28.7021 29.2139C27.8896 30.0264 26.8896 30.2764 25.7646 30.3389C24.6084 30.4014 21.1396 30.4014 19.9834 30.3389C18.8584 30.2764 17.8896 30.0264 17.0459 29.2139C16.2334 28.3701 15.9834 27.4014 15.9209 26.2764C15.8584 25.1201 15.8584 21.6514 15.9209 20.4951C15.9834 19.3701 16.2334 18.3701 17.0459 17.5576C17.8896 16.7451 18.8584 16.4951 19.9834 16.4326C21.1396 16.3701 24.6084 16.3701 25.7646 16.4326C26.8896 16.4951 27.8896 16.7451 28.7021 17.5576C29.5146 18.3701 29.7646 19.3701 29.8271 20.4951ZM28.3271 27.4951C28.7021 26.5889 28.6084 24.4014 28.6084 23.3701C28.6084 22.3701 28.7021 20.1826 28.3271 19.2451C28.0771 18.6514 27.6084 18.1514 27.0146 17.9326C26.0771 17.5576 23.8896 17.6514 22.8896 17.6514C21.8584 17.6514 19.6709 17.5576 18.7646 17.9326C18.1396 18.1826 17.6709 18.6514 17.4209 19.2451C17.0459 20.1826 17.1396 22.3701 17.1396 23.3701C17.1396 24.4014 17.0459 26.5889 17.4209 27.4951C17.6709 28.1201 18.1396 28.5889 18.7646 28.8389C19.6709 29.2139 21.8584 29.1201 22.8896 29.1201C23.8896 29.1201 26.0771 29.2139 27.0146 28.8389C27.6084 28.5889 28.1084 28.1201 28.3271 27.4951Z"
                    fill="#121212"
                  />
                </svg>
              </div>
            </div>

            {/* Social Icons */}
          </div>
        </div>
        <div className="container py-16  space-y-16 lg:space-y-28">
          <FAQ />
        </div>
      </div>
    </div>
  );
};

export default PageContact;
